import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { PublishedStep } from './usePublishedSteps';
import { SMLPublishedStepRow } from './SMLPublishedStepRow';
import { Panel, PanelHead } from '../../music24/components/primitives/Panel';
import styles from './SMLPublishedNextSteps.module.scss';

interface SMLPublishedNextStepsProps {
  steps: PublishedStep[];
  /** Where the release stands: "12 days to release", "out 3 days", "out now". */
  tag?: string;
}

/** The panel that replaced "you can check it out". */
const SMLPublishedNextStepsComponent: React.FC<SMLPublishedNextStepsProps> = ({ steps, tag }) => {
  const intl = useIntl();

  if (steps.length === 0) {
    return null;
  }

  return (
    <Panel as="section" nested>
      <PanelHead
        title={intl.formatMessage({ id: 'app.sml.published.next.title', defaultMessage: 'Worth doing next' })}
        right={tag !== undefined && <span className={styles.tag}>{tag}</span>}
      />
      <div className={styles.rows}>
        {steps.map((step) => (
          <SMLPublishedStepRow key={step.id} step={step} />
        ))}
      </div>
    </Panel>
  );
};

export const SMLPublishedNextSteps = TypedMemo(SMLPublishedNextStepsComponent);
